"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoIcon = exports.ASPERA_REMOVED_TRANSFER_MSG = exports.ASPERA_ACTIVITY_WINDOW_MSG = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./InfoIcon.scss");
exports.ASPERA_ACTIVITY_WINDOW_MSG = 'Open Aspera activity window for more details';
exports.ASPERA_REMOVED_TRANSFER_MSG = 'Transfer has been removed, either manually or automatically';
var InfoIcon = function (props) { return (react_1.default.createElement("span", { className: classnames_1.default('info-icon', 'icon', 'tooltip', props.className), "data-tooltip": props.tooltipMsg },
    react_1.default.createElement("i", { className: "fas fa-info-circle", onClick: props.onClick }))); };
exports.InfoIcon = InfoIcon;
